/**
 * Copyright © Scandiweb, Inc. All rights reserved.
 *
 * @category    Puma
 * @package     Puma_Tamara
 * @author      Beshoy Samuel <info@scandiweb.com>
 */

import { Field } from 'Util/Query';

/** @namespace Scandipwa/Query/Tamara/Query */
export class TamaraQuery {
    getWidgetPdp() {
        return new Field('getTamaraWidgetPdp')
            .addFieldList([
                'script_url',
                'public_key',
                'currency_code',
                'country_code',
                new Field('payment_method')
                    .addFieldList([
                        'name',
                        'min_limit',
                        'max_limit',
                        'currency',
                        'number_of_instalments',
                        'description'
                    ]),
                'error'
            ]);
    }
}

export default new TamaraQuery();
